import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import D8MeasureScore from '../dibels8-summary/D8MeasureScore';
import { localizeDate } from '../../../common/localization';
import { useAppContext } from '../../../common/contexts/AppContext';
import {
    ASSESSMENT_TYPE,
    MEASURE_SCORE_DISPLAY_NAMES,
    DIBELS8_MEASURES,
} from '../../../constants/assessments';
import { resultType, studentType } from '../../../constants/prop-types';

const D8PMResultRow = ({ result, currentMeasure, student, classId }) => {
    const { formsMap } = useAppContext();
    const { measureScores, measure, period, clientId, formUid, clientModDate } = result;
    const { skillName, rawScore } = measureScores[currentMeasure];
    const { id } = student;

    return (
        <div key={`${clientId}-${skillName}-row`} className='dashboard-measure-info'>
            <div className='dashboard-skill'>
                <span className='dashboard-skill-name'>{skillName}</span>
                <span className='dashboard-measure-name'>{MEASURE_SCORE_DISPLAY_NAMES[currentMeasure]}</span>
            </div>
            <div className='dashboard-form'>{get(formsMap, `[${formUid}].label`, '')}</div>
            <div className='dashboard-window-dates'>{localizeDate(clientModDate)}</div>
            <D8MeasureScore
                score={rawScore}
                studentId={id}
                measure={measure}
                period={period}
                classId={classId}
                resultId={clientId}
                fromPage={ASSESSMENT_TYPE.PM}
                isFormAvailable={formsMap.hasOwnProperty(formUid)}
                key={`${clientId}-${skillName}-score`}
            />
        </div>
    );
};

D8PMResultRow.propTypes = {
    student: studentType.isRequired,
    classId: PropTypes.string.isRequired,
    result: resultType.isRequired,
    currentMeasure: PropTypes.oneOf(DIBELS8_MEASURES).isRequired,
};

export default D8PMResultRow;
